var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZapier(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 40,
    height: 40,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_2103_349",
    transform: "translate(0 -0.00625) scale(0.0125)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_2103_349",
    width: 80,
    height: 81,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFAAAABRCAYAAABFTSEIAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAASNSURBVHgB7ZoxTBRBFIYfxsRESLQ57PRotJBABXQYSOgAEyPaCDGICQVng4kWYiEUEsFCrpBILKQR7QArEgl0YIWBQgo92qOBRGzP/RnGfbvs7u3dk+MueV9y4fZ2d3b2m/fezK4SKSKqcl10n5SiqcrdpBwpRXOGFBEqUIgKFKIChahAISpQiAoUogKFqEAhKlCIChSiAoWoQCEqUIgKFKIChahAISpQiAoUogKFqEAhKlCIChSiAoWoQCEqUIgKFFL5As9fJKq9QqfFWapkEo641+tE1Y7EX9+Jhpuo1FR2BPZPGHmgrsH5NFKpqWyBuzve7eoLVGoqO4UXp0z9SzrRt5gm2lylUqP/wVJI/gjsHHLrTD7mxtzvmB1buojqb5hib1n+YCKFpx/qV3O3+Y7JYH3enN+VMtGF62ed4+dGveddb3Xabw2+vu0D2sBxdqZGO+jD2gLRn73gtngf2u+Z6/vbPiJ/BL7djr9MuHXO/IWw0aXw83ATL3uIMhtmu62XKDVjvqPj2Df5zYjlHDg3PN7jpurdZ85n5Pj1D9vscyaZV+GDjz6MdLgDwttaniX6OOq9B94242QmkQcT0dKx7+nn4H3JRnMjfnkAMoZmKC8YwNQ7r7xsxomsDW8fUiFtIeohNEbg5E/hxTfBo4iU48uG7NFI4tgku/mvTrp8GjMzJMTYVEXnkDL+wo/fUTYQBZsr5rzOR+7NhJ3Hwc3zfk0NEG0dHY+BQXSD+tbgtnBfMZdEMQSmj/+GetGZcrdRM8Zvm+9Is8Frbmexz/L+sSsQJEJGeH3B3LQl47TxYsndbuoOF4gBbO9ztyFua9XbV5xr611YW/gN5eJgj6IofBmD2oL0+HchJ0rG7wRfKFflLfKJmLUUyxMObgaRZKPwUkQ7/mskAlKVZ1RNSI1MD+SVBwoTiBTk6YH0TD88fhyiE8fFnb39BHWcCzwfsWCu8e3jA1gI2Z1Yh8UX6JeHJUXQ1I4ZFY9YlrV5d7aFUJ76hRD3KcN/44hmzOxxjy+QeAIx87X3utuoZf40s7Sx+oOOo45YMMPGEYhB4IODNORFnddVPxCCCLbRj0Wav8ahvV2ZOEt+gU+c5UYLK/w2ooJS46fvxhJJsxjFghV/eWRGAckQgeKPm+2f9O7PbESfjxncDhQGHoNthfE1KsQik7aKfwTML5DLs9v+3yyDV731C7Pw9A/nt33TYX90hIHjw9Zoh08Ss9HnQxiiGNfBZ3rbyML32svu9REEaVkk/t+FNCR98aV2NXvh+bwjOv0sUTNgWOngQDKuxesbZNU1eAcP0XfiNbCQNxy/9016IRJRN+3TBJ4AUNMO03LFPT6sDuG44WbThi0VEIo2uEAcF9Y/DBQkYuJLsoUx2rH94akb1VYE5fE2hj8LAwwAjwyb/mVIZbxQLVN5QP9VTkh5pDBSlL/5OIU3y8Wib6SFaAoLUYFCVKAQFShEBQpRgUJUoBAVKEQFClGBQlSgEBUoRAUKUYFCVKAQFShEBQpRgUJUoBAVKEQFClGBQlSgEBUoRAUKUYFCVKCQvwAtYeNrBIXNAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZapier);
export default __webpack_public_path__ + "static/media/zapier.6b5d86c0538c42825c7a02678f42ecfc.svg";
export { ForwardRef as ReactComponent };